/* eslint-disable */
import React from 'react';
// import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function WebsiteBanner() {
    
    return (
        <>

        <div className="banner">
            <img
                src='../../assets/images/website.jpg'
                alt="Website Development and Design Services - ConnectMyVA"
                    title="WordPress, Joomla & eCommerce Website Solutions - ConnectMyVA"
                className="bannerImage"
            />			
        </div>
            
            

        </>
    )
}

export default WebsiteBanner
